import type { ServicePage } from "./types";

export const novasBairroPages: ServicePage[] = [
  {
    slug: "chaveiro-sao-caetano-betim",
    keyword: "chaveiro são caetano betim",
    title: "Chaveiro no São Caetano, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro São Caetano em Betim: abertura de portas, troca de fechaduras, cópia de chaves e controles de portão. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro no bairro São Caetano, Betim",
    lead: "Precisa de chaveiro no São Caetano? A Chavel atende o bairro com abertura de portas, troca de fechaduras, cópia de chaves e controles de portão, com a tradição de quem trabalha em Betim desde 1975.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro São Caetano, em Betim, com abertura de portas, troca de segredo e de fechaduras, cópia de chaves comuns e codificadas e controles de portão. Loja na Av. Amazonas, 1354 - Brasiléia. Contato e WhatsApp: (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços de chaveiro mais pedidos no São Caetano",
        paragraphs: [
          "O São Caetano tem perfil residencial, com casas, sobrados e portões de garagem. Por isso, a maior parte dos chamados envolve portas de entrada, portões sociais e controles remotos.",
        ],
        bullets: [
          "Abertura de porta com chave esquecida dentro de casa",
          "Troca de segredo após perda ou roubo de chaves",
          "Instalação e troca de fechaduras de porta e portão",
          "Cópia de controle de portão eletrônico",
          "Cópia de chave codificada de carro e moto",
        ],
      },
      {
        h2: "Como pedir atendimento no São Caetano",
        paragraphs: [
          "Chame no WhatsApp informando o serviço, a rua e uma foto da fechadura ou da chave, se possível. Com isso já passamos a orientação e o orçamento antes de qualquer serviço.",
        ],
        h3: [
          {
            title: "Atendimento na loja",
            text: "Cópias de chaves e controles podem ser feitas na loja da Av. Amazonas, no Brasiléia, de segunda a sexta das 8h às 18h e aos sábados das 8h às 13h.",
          },
          {
            title: "Atendimento no local",
            text: "Para aberturas e instalações, o técnico vai até o endereço no São Caetano com as ferramentas e peças necessárias.",
          },
        ],
      },
      {
        h2: "Dicas de segurança para casas do São Caetano",
        paragraphs: [
          "Ao se mudar para um imóvel, troque o segredo das fechaduras: você não sabe quantas cópias das chaves antigas existem. Em portões externos, a lubrificação periódica evita travamentos causados por chuva e poeira.",
        ],
      },
    ],
    faq: [
      {
        q: "A Chavel atende no bairro São Caetano em Betim?",
        a: "Sim. Atendemos o São Caetano com abertura de portas, fechaduras, cópia de chaves e controles de portão. Chame no WhatsApp (31) 3531-3544.",
      },
      {
        q: "Vocês passam o orçamento antes do serviço?",
        a: "Sim. O valor é informado antes de começar, depois de entendermos o tipo de porta, fechadura ou chave.",
      },
      {
        q: "Fazem troca de segredo de fechadura no São Caetano?",
        a: "Sim. A troca de segredo mantém a fechadura e inutiliza as chaves antigas, e normalmente custa menos que trocar a fechadura inteira.",
      },
    ],
    related: ["chaveiro-betim", "chaveiro-a-domicilio", "controle-de-portao", "fechaduras-de-porta"],
  },
  {
    slug: "chaveiro-laranjeiras-betim",
    keyword: "chaveiro laranjeiras betim",
    title: "Chaveiro no Laranjeiras, Betim | Chavel | (31) 3531-3544",
    description:
      "Chaveiro no bairro Laranjeiras em Betim: abertura de portas e carros, cópia de chaves, fechaduras e controles de portão. WhatsApp (31) 3531-3544.",
    h1: "Chaveiro no bairro Laranjeiras, Betim",
    lead: "Ficou sem conseguir entrar em casa ou precisa de uma cópia de chave no Laranjeiras? A Chavel atende o bairro com serviços residenciais e automotivos, com orçamento antes do serviço.",
    category: "bairro",
    quickAnswer:
      "A Chavel atende o bairro Laranjeiras, em Betim, com abertura de portas e veículos, troca de fechaduras, cópia de chaves comuns e codificadas e controles de portão. Loja na Av. Amazonas, 1354 - Brasiléia. Contato e WhatsApp: (31) 3531-3544.",
    sections: [
      {
        h2: "O que a Chavel faz no Laranjeiras",
        paragraphs: [
          "Atendemos tanto casas quanto veículos no Laranjeiras. Os pedidos mais comuns são aberturas de emergência, cópias de chaves e manutenção de fechaduras externas.",
        ],
        bullets: [
          "Abertura de portas residenciais sem danificar a fechadura, sempre que possível",
          "Abertura de carro com a chave trancada dentro",
          "Troca e instalação de fechaduras e cadeados",
          "Cópia de chave codificada e chave canivete",
          "Cópia e programação de controle de portão",
        ],
      },
      {
        h2: "Atendimento residencial e automotivo",
        paragraphs: [
          "Com mais de 50 anos de experiência em Betim, a Chavel trabalha com fechaduras de diferentes marcas e com chaves de carros nacionais e importados.",
        ],
        h3: [
          {
            title: "Para sua casa",
            text: "Fechaduras de porta de madeira, fechaduras de portão, fechadura elétrica e fechadura digital, com instalação e ajuste.",
          },
          {
            title: "Para seu carro",
            text: "Abertura de veículos, cópia de chave codificada e conserto ou troca de carcaça de chave canivete.",
          },
        ],
      },
      {
        h2: "Como chamar o chaveiro no Laranjeiras",
        paragraphs: [
          "Envie pelo WhatsApp o serviço, o endereço e, se puder, uma foto da fechadura ou da chave. Assim conseguimos levar a peça certa e informar o orçamento antes do atendimento.",
        ],
      },
    ],
    faq: [
      {
        q: "A Chavel atende no bairro Laranjeiras em Betim?",
        a: "Sim. Atendemos o Laranjeiras com serviços residenciais e automotivos. Chame no WhatsApp (31) 3531-3544.",
      },
      {
        q: "Vocês abrem carro no Laranjeiras?",
        a: "Sim. Fazemos abertura de veículos com técnica que evita danos à porta e à pintura.",
      },
      {
        q: "Preciso levar a chave original para fazer cópia?",
        a: "Para cópia de chave comum ou codificada, sim, é o caminho mais rápido e barato. Sem a original, avaliamos o caso pelo WhatsApp.",
      },
    ],
    related: ["chaveiro-betim", "abertura-de-veiculos-betim", "chave-canivete-betim", "chaveiro-a-domicilio"],
  },
];

export const novasAutomotivoPages: ServicePage[] = [
  {
    slug: "abertura-de-veiculos-betim",
    keyword: "abertura de veículos betim",
    title: "Abertura de Veículos em Betim | Chavel | (31) 3531-3544",
    description:
      "Abertura de carros em Betim com chave trancada dentro, sem danificar porta ou pintura. Chaveiro automotivo Chavel, desde 1975. WhatsApp (31) 3531-3544.",
    h1: "Abertura de veículos em Betim",
    lead: "Trancou a chave dentro do carro? A Chavel faz abertura de veículos em Betim com ferramentas próprias para não danificar a porta, a borracha ou a pintura.",
    category: "automotivo",
    quickAnswer:
      "A Chavel faz abertura de carros em Betim quando a chave fica trancada dentro do veículo ou a fechadura trava. O técnico vai até o local com ferramentas que evitam danos à porta e à pintura. Contato e WhatsApp: (31) 3531-3544.",
    sections: [
      {
        h2: "Quando chamar a abertura de veículos",
        paragraphs: [
          "A situação mais comum é a chave esquecida no contato, no banco ou no porta-malas com o carro travado. Também atendemos fechaduras de porta emperradas e chaves quebradas dentro do miolo.",
        ],
        bullets: [
          "Chave trancada dentro do carro",
          "Chave quebrada na fechadura da porta",
          "Fechadura da porta ou do porta-malas travada",
          "Bateria da chave presencial descarregada com o carro trancado",
        ],
      },
      {
        h2: "Como é feita a abertura sem danos",
        paragraphs: [
          "Usamos ferramentas específicas para destravar o veículo pela fechadura ou pela trava interna, sem quebrar vidro e sem forçar a lataria. Antes de começar, o técnico explica o procedimento e confirma o orçamento.",
        ],
        h3: [
          {
            title: "Comprovação de propriedade",
            text: "Por segurança, pedimos o documento do veículo ou outro comprovante de que o carro é seu antes ou logo depois da abertura.",
          },
          {
            title: "Depois da abertura",
            text: "Se a chave estiver danificada ou você quiser uma reserva, fazemos a cópia de chave codificada ou o reparo da chave canivete.",
          },
        ],
      },
      {
        h2: "Como pedir atendimento em Betim",
        paragraphs: [
          "Chame no WhatsApp com o modelo e o ano do carro e o local onde ele está. Com essas informações já informamos o orçamento e a previsão de chegada.",
        ],
      },
    ],
    faq: [
      {
        q: "A abertura de carro danifica a porta?",
        a: "Não deve danificar. Usamos ferramentas próprias para abertura automotiva, que destravam o veículo sem quebrar vidro nem marcar a pintura.",
      },
      {
        q: "Precisa comprovar que o carro é meu?",
        a: "Sim. Por segurança, pedimos o documento do veículo ou outro comprovante de propriedade.",
      },
      {
        q: "Vocês atendem em qualquer bairro de Betim?",
        a: "Atendemos Betim e os bairros da nossa área de atendimento. Informe o local pelo WhatsApp (31) 3531-3544.",
      },
    ],
    related: ["chaveiro-automotivo-betim", "chave-canivete-betim", "chave-codificada", "chaveiro-urgente"],
  },
  {
    slug: "chave-canivete-betim",
    keyword: "chave canivete betim",
    title: "Chave Canivete em Betim: Cópia e Conserto | Chavel",
    description:
      "Cópia, conserto e troca de carcaça de chave canivete em Betim, com codificação do chip. Chavel Chaveiro, desde 1975. WhatsApp (31) 3531-3544.",
    h1: "Chave canivete em Betim: cópia, conserto e troca de carcaça",
    lead: "Chave canivete quebrada, com a lâmina solta ou os botões gastos? A Chavel faz cópia, conserto e troca de carcaça de chave canivete em Betim, incluindo a codificação do chip.",
    category: "automotivo",
    quickAnswer:
      "A Chavel faz cópia de chave canivete com chip codificado, troca de carcaça, troca de botões e reparo da mola da lâmina, em Betim. Na troca de carcaça, o chip e a placa originais são reaproveitados. Loja na Av. Amazonas, 1354 - Brasiléia. WhatsApp (31) 3531-3544.",
    sections: [
      {
        h2: "Serviços para chave canivete",
        paragraphs: [
          "A chave canivete reúne lâmina dobrável, controle do alarme e chip de partida. Por isso, cada defeito pede um tipo de serviço diferente.",
        ],
        bullets: [
          "Cópia de chave canivete com codificação do chip",
          "Troca de carcaça quebrada ou desgastada",
          "Troca de botões de borracha gastos",
          "Reparo da mola e do pino da lâmina",
          "Troca da bateria do controle",
        ],
      },
      {
        h2: "Conserto ou chave nova: qual escolher",
        paragraphs: [
          "Quando só a parte externa está danificada, a troca de carcaça resolve e mantém o chip e a placa originais. Quando a chave foi perdida ou você quer uma reserva, o caminho é a cópia com codificação.",
        ],
        h3: [
          {
            title: "Troca de carcaça",
            text: "Transferimos a placa do controle e o chip para uma carcaça nova e cortamos a lâmina no segredo do seu carro.",
          },
          {
            title: "Cópia codificada",
            text: "Cortamos a lâmina e programamos o chip para o carro reconhecer a nova chave na partida.",
          },
        ],
      },
      {
        h2: "Como fazer o orçamento",
        paragraphs: [
          "Envie pelo WhatsApp o modelo e o ano do carro e uma foto da chave. Assim informamos se é caso de conserto ou de chave nova e o valor antes do serviço.",
        ],
      },
    ],
    faq: [
      {
        q: "Dá para trocar só a carcaça da chave canivete?",
        a: "Sim. Reaproveitamos o chip e a placa originais e trocamos apenas a parte externa, que é o que costuma quebrar.",
      },
      {
        q: "A cópia da chave canivete liga o carro?",
        a: "Sim. Além de cortar a lâmina, programamos o chip para que o carro reconheça a nova chave na partida.",
      },
      {
        q: "Quanto custa a chave canivete em Betim?",
        a: "Depende do modelo do carro e do serviço (conserto, carcaça ou cópia). Envie o modelo e uma foto pelo WhatsApp (31) 3531-3544 para receber o orçamento.",
      },
    ],
    related: ["chave-codificada", "fazer-copia-de-chave-codificada-preco", "abertura-de-veiculos-betim", "chaveiro-automotivo-betim"],
  },
];
